import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../../../constants/TextConstants'
import { PaginationButton } from '../styles'
import { BqIcon } from '@beeq/react'

const LastPageControl = ({ endPage, totalPages, onPageChange }) => {
  const shouldRenderButton = endPage < totalPages
  const shouldRenderEllipsisIndicator = endPage < totalPages - 1

  return (
    <>
      {shouldRenderButton && (
        <>
          {shouldRenderEllipsisIndicator && <BqIcon fill name='dots-three' />}
          <PaginationButton
            size='small'
            appearance='text'
            onBqClick={() => onPageChange(totalPages)}
            title={`${Text.PageControlPageTitle} ${totalPages}`}>
            {totalPages}
          </PaginationButton>
        </>
      )}
    </>
  )
}

export default LastPageControl

LastPageControl.propTypes = {
  endPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
}
